import { ConfiguracionMeeting } from 'qreventos-suite/meeting';
import { CommonService } from 'qreventos-suite/src/services/common.services';

export class ConfiguracionMeetingService extends CommonService {

  private LOCAL_STORAGE_NAME = "UDATA_CFG";

  get(): ConfiguracionMeeting | undefined {
    const data = localStorage.getItem(this.LOCAL_STORAGE_NAME);
    if (!data) {
      return undefined;
    }

    const json = atob(data);
    return JSON.parse(json) as ConfiguracionMeeting;
  }
  
  save(configuracionMeeting: ConfiguracionMeeting) {
    const json = JSON.stringify(configuracionMeeting);
    const base64 = btoa(json);
    localStorage.setItem(this.LOCAL_STORAGE_NAME, base64);
  }

  remove() {
    localStorage.removeItem(this.LOCAL_STORAGE_NAME);
  }

}

export default new ConfiguracionMeetingService();

